export const baseURL = "https://alc.legal/strapi/api"
export const testURL = "http://localhost:1337/api"
export const publicGalleryURL = "https://alc.legal/strapi"
export const apiURL = "https://alc.legal/strapi/api"